"use client";

import React from "react";
import ContactUsMain from "./ContactUsMain";

const ContactUsPage = () => {
  return (
    <>
      <section className="about-us-page global-inner-page-pm">
        <div className="container">
          <div className="text-center">
            <h1 className="inner-first-heading mb-3 !text-[23px]">
              Contact Us
            </h1>
            <div
              className="w-10 h-1 bg-orange-500 mx-auto mt-2 mb-4"
              style={{ background: "#f26624" }}
            ></div>
          </div>

          <ContactUsMain></ContactUsMain>
        </div>
      </section>

      <style jsx>
        {`
          .vision-mission-container {
            display: flex;
            justify-content: space-between;
            box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
            padding: 40px;
            border-radius: 8px;
            color: #fff;
          }

          .vision-section,
          .mission-section {
            width: 45%;
          }

          .vision-mission-container h2 {
            font-size: 24px;
            font-weight: bold;
            color: #fff;
            margin-bottom: 10px;
          }

          .vision-mission-container p {
            color: #fff;
            line-height: 1.6;
          }

          .vision-section {
            border-right: 2px solid #ccc;
            padding-right: 20px;
          }

          .vision-section h2,
          .mission-section h2 {
            color: #fff;
          }

          .vision-mission-container h2 {
            text-align: left;
          }

          @media (max-width: 767px) {
            .vision-section,
            .mission-section {
              width: 100%;
            }
            .vision-section {
              border-right: none;
              padding-right: 0px;
            }

            .vision-mission-container {
              display: block;
              padding: 20px;
            }
          }
        `}
      </style>
    </>
  );
};

export default ContactUsPage;
